module.exports = __webpack_public_path__ + "img/en-1.9bf13a39.jpg";